import React from 'react';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import NativeAjax from '../../util/NativeAjax';
import HmAjax from '../../util/HmAjax';
import Select from 'react-select';
import '../../css/prelogin/react-select.css';
import PreLoginPage from '../core/PreLoginPage';
import HmEventRegistry from '../../model/HmEventRegistry';
import ComponentRegistry from '../../model/ComponentRegistry';


let selectSchoolReq = "Select Your School";
let selectLevelReq = "Select Your Level";
let maxSpecialCharLength = 150;
let minUserNameLength = 6;
let minPasswordLength = 6;
let minHodNameLength = 6;
let minTicNameLength = 6;

export default class AdminModal extends PreLoginPage{

    constructor(props){
        super(props)
        this.state={
            ModalShow:props.modalShow || false,
            selectedOption: '',
            selectedSchoolOption: null,
            selectedLevelOption:null,
            selectedClassOption:null,
            schoolName:"",
            hod_name:"",
            hod_email:"",
            tic_name:"",
            tic_contactno:"",
            tic_email:"",
            password_newacc:"",
            confirmpassword_newacc:"",
            act_key:"",
            submitButtonDisabled: false,
            serverMessage:"",
            stud_name:"",
            stud_email:"",
            stud_gender:"",
            stud_prep_status:"no",
            levelName:"",
            stud_class:"",
            schoolsLoaded: false,
            sectionName:"",
            tic_check:false
        }
        this.userData = null;
        this.hideAdminModal = this.hideAdminModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleRegSubmit = this.handleRegSubmit.bind(this);
        this.handleCheck  = this.handleCheck.bind(this);
        this.handleCreateSubmit = this.handleCreateSubmit.bind(this);
        this.handleEditSubmit = this.handleEditSubmit.bind(this);

        this.renderUserprofileData = this.renderUserprofileData.bind(this);
        this.schoolDropdownChange = this.schoolDropdownChange.bind(this);

        this.levelDropdownChange = this.levelDropdownChange.bind(this);
        this.sectionDropdownChange = this.sectionDropdownChange.bind(this);
        this.schoolListForReg = [];	
        this.schoolLevelList = [];
        this.getUserNameFn = this.getUserNameFn.bind(this);
        this.schoolSubClassList = [];
        this.getCount = this.getCount.bind(this);
        this.validateEmailField = this.validateEmailField.bind(this);
        
    }

    componentDidMount(){
        let userMinLength = (window.minLength && window.minLength[this.getContestHost()]) ? window.minLength[this.getContestHost()] : null;
        if(userMinLength){
            minUserNameLength = (userMinLength.username) ? userMinLength.username : 6;
            minPasswordLength = (userMinLength.password) ? userMinLength.password : 6;
            minHodNameLength =  (userMinLength.hodname) ? userMinLength.hodname : 6;
            minTicNameLength =  (userMinLength.ticname) ? userMinLength.ticname : 6;
        }

        console.warn(userMinLength);
        this.setState({ModalShow:this.props.modalShow});
        this.eraseState()
        this.calltheAPI();
       // console.log("Blob Size ",new Blob(["abdulkadhar"]).size);
        //this.populateContactDropdown();	
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    }

    calltheAPI(){
        let type = this.props.type || '';
        let dataObj = this.props.dataObj || null;
       // console.log("dataObj ",dataObj);
        switch(type){
         case "register":
         this.getContestSchoolName(dataObj);
         break;
         case "create":
         this.getContestLevelName(dataObj);
         case "edit":
         this.getContestLevelName(dataObj);
         break;
         default:
         //console.log("type ",type);
        }
    }

    getContestLevelName(oldData = null){
        let me=this;

        var callBackSuccess=function(response){
            //console.log("getContestLevelName ",response);
            if(response!==null){
                if(response.status=="success"){
                    if(response.levelSecInfo){
                        me.populateSchoolLevelDropdown(response.levelSecInfo);
                    }
                    let type =  me.props.type || '';
                    if(type=="edit"){
                       me.renderLevelForEditStudent()
                    }
                }
            }
        }

        var callBackFailure=function(response){
            //console.log("response school failure",response);
        }

        if(oldData){
            callBackSuccess.apply(this, [oldData]);
        }else {
            new HmAjax(this.getUrlFor("CONTEST_TIC_LEV_AND_SEC").replace("{#contestId}",this.getContestHost())).get(callBackSuccess, callBackFailure);
        }
    }

    componentWillReceiveProps(){
        let me =this;
        this.setState({ModalShow:this.props.modalShow})
        setTimeout(()=>{
            //console.log("componentWillReceiveProps ",this.props.type);
            me.eraseState()
            me.calltheAPI();
        },50)
    }

    eraseState(){
        let type = this.props.type || '';
        //console.log("edit ",type);
        switch(type){
        case "register":
            this.renderRegisterData();
        break;
        case "create":
            this.renderCreateStudentData();
        break;
        case "edit":
            this.renderEditUserData();
        break;
        default:
           //console.log("type ",type);
        } 

    }

    renderRegisterData(){
        this.setState({ 
            schoolName:"",
            hod_name:"",
            hod_email:"",
            tic_name:"",
            tic_contactno:"",
            tic_email:"",
            password_newacc:"",
            confirmpassword_newacc:"",
            act_key:"",
            serverMessage:"",
            submitButtonDisabled:false});
    }

    renderCreateStudentData(){
        this.setState({
            stud_name:"",
            stud_email:"",
            stud_gender:"",
            stud_prep_status:"no",
            serverMessage:"",
            sectionName:"",
            stud_class:"",
            submitButtonDisabled:false});
    }

    renderEditUserData(){
        //console.log("renderUserData",this.props.userData);
        let type = this.props.type  || '';
        this.userData = null;
        let me=this;
        if(type=="edit"){
            this.userData = this.props.userData || null;

            if(this.userData){
                //console.log("userdata available ",this.userData);
                me.setState({
                    stud_name:(this.userData["Student Name"]!=='null')?this.userData["Student Name"] : "",
                    stud_gender:(this.userData["gender"]).toLowerCase(),
                    stud_prep_status:(this.userData["Prep Course"]!=='null') ? (this.userData["Prep Course"]).toLowerCase() : '',
                    stud_email:(this.userData["Email ID"]!=='null')?this.userData["Email ID"] : "",
                    levelName:(this.userData["Level"]!=='null')?this.userData["Level"] : "",
                    stud_class:(this.userData["Class"]!=='null')?this.userData["Class"] : "",
                    serverMessage:""
                });
            }
        }
    }

    schoolDropdownChange(selectedOption){
        var me = this;
        let serverMsg = this.state.serverMessage;
        if(serverMsg!==""){
            this.setState({schoolName:selectedOption.label,selectedSchoolOption:selectedOption,serverMessage:""});
        }else{
            this.setState({schoolName:selectedOption.label,selectedSchoolOption:selectedOption});
        }
        
        this.setState({schoolName:selectedOption.label,selectedSchoolOption:selectedOption});
    }

    levelDropdownChange(selectedOption){
        var me = this;
        //console.log("selectedOption ",selectedOption);
        let serverMsg = this.state.serverMessage;
        if(serverMsg!==""){
            this.setState({levelName:selectedOption.label,selectedLevelOption:selectedOption,serverMessage:""});
        }else{
            this.setState({levelName:selectedOption.label,selectedLevelOption:selectedOption});
        }
        
        //this.populateSchoolSectionDropdown(this.schoolClassList[selectedOption.index]);
    }

    sectionDropdownChange(selectedOption){
        var me = this;
        this.setState({sectionName:selectedOption.label,selectedClassOption:selectedOption});
    }
    
    hideAdminModal(e,response=null){
        if(typeof this.props.callBackParent ==="function"){
            this.props.callBackParent(response);
        }
    }

    radioChange(e) {
        const target = e.currentTarget;	
        if(typeof this.props.callBack === "function"){
          this.props.callBack(e);
        }
    
        //console.log("radioChange ",e.target.value)
          this.setState({
    		[target.name]: target.value,
    	});

      }
     
    handleRegSubmit(e){
        //console.log("regsubmit triggered");
        e.preventDefault();

        let schoolName = this.state.schoolName.trim();
        let tic_name = this.state.tic_name.trim();
        let tic_contactno = this.state.tic_contactno.trim();
        let tic_email = this.state.tic_email.trim();
        let hod_name = this.state.hod_name.trim();
        let hod_email = this.state.hod_email.trim();
        let act_key = this.state.act_key.trim();
        let password_newacc = this.state.password_newacc.trim();

        this.setState({schoolName:schoolName,tic_name:tic_name,
            tic_contactno:tic_contactno,
            tic_email:tic_email,hod_name:hod_name,
            hod_email:hod_email,act_key:act_key,
            password_newacc:password_newacc})

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   
			this.userRegisterForm();  
		}
    }

    handleCreateSubmit(e){
       // console.log("regsubmit triggered");
        e.preventDefault();

        let userName = this.state.stud_name.trim();
        let emailId = this.state.stud_email.trim();
        let studClass = this.state.stud_class.trim();
        this.setState({stud_name:userName,stud_email:emailId,stud_class:studClass});
   
        this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   
			this.userAddStudentForm();  
		}
    }

    handleEditSubmit(e){
        //console.log("regsubmit triggered");
        e.preventDefault();

        let userName = this.state.stud_name.trim();
        let emailId = this.state.stud_email.trim();
        let studClass = this.state.stud_class.trim();
        this.setState({stud_name:userName,stud_email:emailId,stud_class:studClass});

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   
			this.userEditStudentForm();  
		}
    }

    handleCheck(e){
        let me=this;
        const target = e.currentTarget;	
        let check = me.state.tic_check;
        let hodName = me.state.hod_name;
        let hodEmail = me.state.hod_email;
        me.setState({
            ["tic_name"]: (!check) ? hodName:"",
            ["tic_email"]: (!check) ? hodEmail:"",
            [target.name]:!check
        });
    }

    getContestSchoolName(oldData = null){
        let me=this;
        let contestName = this.getSelectedContestGroup();
        var formData = {
            "countryCodeList":window.TIC_schoolList[contestName]
        }

        var callBackSuccess=function(response){
            //console.log("response school success",response);
            if(response!==null){
                if(response.status=="success"){
                    if(response.schoolsList){
                        me.populateSchoolDropdown(response.schoolsList);
                    }
                    setTimeout(()=>{
                        window.contestSchoolLoadTriggered = false;
                    }, 5000);
                }
            }
        }

        var callBackFailure=function(response){
            window.contestSchoolLoadTriggered = false;
            //console.log("response school failure",response);
            me.setState({schoolsLoaded:false});
        }

        
        if(oldData){
            callBackSuccess.apply(this, [oldData]);
        }else if(!this.state.schoolsLoaded && !window.contestSchoolLoadTriggered){
            //console.log("getContestSchoolName AM");
            window.contestSchoolLoadTriggered = true;            
            new NativeAjax(this.getUrlFor("CONTEST_TIC_GET_SCHOOL").replace("{#contestId}",this.getSelectedContestGroup())).enableCORS().get(callBackSuccess, callBackFailure);
            /*new NativeAjax((this.getUrlFor("CONTEST_TIC_GET_SCHOOL").replace("{#contestId}",this.getSelectedContestGroup())),formData).enableCORS().post(callBackSuccess, callBackFailure);*/
        }
    }
    
    populateSchoolDropdown(schoolList) {    
        let indexVal = 0;
        let schoolListForReg =[];
        schoolListForReg.push({"label":selectSchoolReq,"value":0})
        schoolList.map((school,index) => {
            schoolListForReg.push({"label":school,"value":index+1})
        });

        this.schoolListForReg = schoolListForReg;
        
        this.setState({schoolsLoaded:true, schoolName:schoolListForReg[0].label,selectedSchoolOption:schoolListForReg[0]});
        //console.log("dropdown issue ",this.state.schoolName +" : ",schoolListForReg[0].label)
    }

    populateSchoolLevelDropdown(levelList){
        let schoolLevelList = [];
        schoolLevelList.push({"label":selectLevelReq,"value":0,"index":0})
        Object.values(levelList).map((level,index) => {
            schoolLevelList.push({"label":level.levelName,"value":level.levelId,"index":index+1})

        });
        
        this.schoolLevelList = schoolLevelList.sort(function(a, b){
            if(a.value < b.value) { return -1; }
            if(a.value > b.value) { return 1; }
            return 0;
        });

        this.setState({levelName:schoolLevelList[0].label,selectedLevelOption:schoolLevelList[0]});
    }
    

    populateSchoolSectionDropdown(secList){
       let secArray = [];
       secArray = Object.values(secList);
       this.schoolSubClassList = secArray;
       this.setState({sectionName:secArray[0].label,selectedClassOption:secArray[0]});
       //console.log("this.schoolClassList DD ",this.schoolClassList);
    }

    renderLevelForEditStudent(){
        let userData = this.userData || null;
        let lev = userData["Level"] || '';
        let levGrade = 0;
        let secGrade = 0;
        let sec = userData["Class"] || '';
        if(lev!=""){
            levGrade = this.getDropdownOrder(this.schoolLevelList,lev);
            this.setState({levelName:this.schoolLevelList[levGrade].label,selectedLevelOption:this.schoolLevelList[levGrade]});
        }
    }

    getDropdownOrder(groupList,ddTxt){
        let orderNo = 0;
        for(var i=0;i<groupList.length;i++){
            if(groupList[i].label === ddTxt){
                orderNo = i;
                break;
            }
        }
        return orderNo;
    }
    
    userAddStudentForm = function(){
        //let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let email = "";
        let emailId = this.state.stud_email.trim();
        let studClass = this.state.stud_class.trim(); 

        this.setState({serverMessage:""});
        
        if((this.state.stud_gender.toLowerCase()!=="m" && this.state.stud_gender.toLowerCase()!=="f")){
            this.setState({serverMessage:this.rb("contest.stu_upload.gendererror")});
            return;
        }

        if(this.state.levelName === selectLevelReq){
            this.setState({serverMessage:this.rb("contest.edit.levelerror")});
            return;
        }

        if(studClass.length<1){
            this.setState({serverMessage:this.rb("contest.edit.classerror"),stud_class:studClass});
            return;
        }

        if(this.prepCourseAvailable() && (this.state.stud_prep_status.toLowerCase()!=="yes" && this.state.stud_prep_status.toLowerCase()!=="no")){
            this.setState({serverMessage:this.rb("contest.stu_upload.preperror")});
            return;
        }
        
        if(emailId.length>0){
            if(emailRegex.test(emailId)){
                email =  emailId;
            }else{
                this.setState({serverMessage:this.rb("contest.stu_upload.emailerror")});
                return;
            }
        }

        var formData = {
            "userList": [
                {
                    "userName": this.state.stud_name,
                    "email": email,
                    "gender": this.state.stud_gender.toLowerCase(),
                    "levelSecMap": {
                        "levelSecMapId": 0,
                        "levelId": 0,
                        "sectionId": 0,
                        "levelName": this.state.levelName,
                        "sectionName": studClass
                    },
                    "prepPurchaseStatus": this.state.stud_prep_status.toLowerCase()
                }
            ]
        }
        

        var me =this;
		me.setState({serverMessage:"",submitButtonDisabled: true});

		
		var callBackSuccess = function(response){
			
			if(response !== null){
                //console.log("userRegisterForm success",response);
                if(response.isValidReq){
                    if(response.insertStatus==="success"){
                        me.getCount();
                        let existingUsers = (response.existingUsers) ? JSON.parse(response.existingUsers) : null;
                        me.hideAdminModal(this,JSON.parse(existingUsers));
                    }else {
                        switch(response.insertStatus)
                        {
                            case "invalid_level_sec_data":
                            me.setState({submitButtonDisabled: false, serverMessage: me.rb("contest.stu_upload.lev_sec_error")});
                            break;
                            case "contest_communication_failure":
                            me.setState({submitButtonDisabled: false, serverMessage: me.rb("503.msg")});
                            break;
                            default:
                            me.setState({submitButtonDisabled: false, serverMessage: response.insertStatus }); 
                        }
                    }
                }else{
                    let errMsg = (response && (response.validationErrorsList) && (response.validationErrorsList).length>0) ? response.validationErrorsList[0] : "";
                    me.setState({submitButtonDisabled: false, serverMessage: me.rb(errMsg)});
                }
            }	
            me.setState({submitButtonDisabled: false});
		}


		var callBackFailure = function(response){
            //console.log("userRegisterForm failure",response);
			me.setState({submitButtonDisabled: false});
        }
        let contest_host = this.props.contest_host || this.getSelectedContestGroup();
       
		new HmAjax(this.getUrlFor("CONTEST_STU_BULK_REG")+("?action=create&contest_host="+contest_host),formData).mask().post(callBackSuccess, callBackFailure);

    }

    userEditStudentForm = function(){
        
        //let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let email = "";
        let emailId = this.state.stud_email.trim();
        let studClass = this.state.stud_class.trim(); 
        this.setState({serverMessage:""});

        if((this.state.stud_gender.toLowerCase()!=="m" && this.state.stud_gender.toLowerCase()!=="f")){
            this.setState({serverMessage:this.rb("contest.stu_upload.gendererror")});
            return;
        }

        if(this.state.levelName === selectLevelReq){
            this.setState({serverMessage:this.rb("contest.edit.levelerror")});
            return;
        }

        if(studClass.length<1){
            this.setState({serverMessage:this.rb("contest.edit.classerror"),stud_class:studClass});
            return;
        }

        if((this.state.stud_prep_status.toLowerCase()!=="yes" && this.state.stud_prep_status.toLowerCase()!=="no")){
            this.setState({serverMessage:this.rb("contest.stu_upload.preperror")});
            return;
        }

        if(emailId.length>0){
            if(emailRegex.test(emailId)){
                email =  emailId;
            }else{
                this.setState({serverMessage:this.rb("contest.stu_upload.emailerror")});
                return;
            }
        }

        var formData = {
            "userList": [
                {
                    "userName": this.state.stud_name,
                    "email": email,
                    "gender": this.state.stud_gender.toLowerCase(),
                    "levelSecMap": {
                        "levelSecMapId": 0,
                        "levelId": 0,
                        "sectionId": 0,
                        "levelName": this.state.levelName,
                        "sectionName":studClass,
                    },
                    "prepPurchaseStatus": this.state.stud_prep_status.toLowerCase(),
                    "userId": this.userData["userId"] || '',
                    "loginId": this.userData["User ID"] || '',
                    "userRefId":this.userData["userRefId"] || ''
                }
            ]
        }

        var me =this;
		me.setState({serverMessage:"",submitButtonDisabled: true});

		
		var callBackSuccess = function(response){
			
			if(response !== null){
                //console.log("userRegisterForm success",response);
                if(response.isValidReq){
                    if(response.insertStatus==="success"){
                        let existingUsers = (response.existingUsers) ? JSON.parse(response.existingUsers) : null;
                        me.hideAdminModal(this,JSON.parse(existingUsers));
                    }else {
                        switch(response.insertStatus)
                        {
                            case "invalid_level_sec_data":
                            me.setState({submitButtonDisabled: false, serverMessage: me.rb("contest.stu_upload.lev_sec_error")});
                            break;
                            case "contest_communication_failure":
                            me.setState({submitButtonDisabled: false, serverMessage: me.rb("503.msg")});
                            break;
                            default:
                            me.setState({submitButtonDisabled: false, serverMessage: response.insertStatus }); 
                        }
                    }
                }else{
                    let errMsg = (response && (response.validationErrorsList) && (response.validationErrorsList).length>0) ? response.validationErrorsList[0] : "";
                    me.setState({submitButtonDisabled: false, serverMessage: me.rb(errMsg)});
                }
            }	
            me.setState({submitButtonDisabled: false});
		}


		var callBackFailure = function(response){
            //console.log("userRegisterForm failure",response);
			me.setState({submitButtonDisabled: false});
        }
        let contest_host = this.props.contest_host || this.getSelectedContestGroup();
        let actStatus =  this.props.status || "pending";
        new HmAjax(this.getUrlFor("CONTEST_STU_BULK_REG")+("?action=update&contest_host="+contest_host+"&status="+actStatus),formData).mask().post(callBackSuccess, callBackFailure);
    }

    userRegisterForm = function(){
        //console.log("this.props.contest_host ",this.props.contest_host)
        this.setState({serverMessage:""});
        if(this.state.schoolName === selectSchoolReq){
            this.setState({serverMessage:this.rb("contest.reg.schoolerror")});
            return;
        }

		var formData = {
            "schoolName":this.state.schoolName,
            "contactName":this.state.tic_name,
            "contactNum":this.state.tic_contactno,
            "contactEmail":this.state.tic_email,
            "hodName":this.state.hod_name,
            "hodEmail":this.state.hod_email,
            "activationKey":this.state.act_key,
            "password":this.state.password_newacc,
            "contest_host": this.props.contest_host || this.getSelectedContestGroup()
        }
		
		var me =this;
		me.setState({serverMessage:"",submitButtonDisabled: true});

		
		var callBackSuccess = function(response){
			
			if(response !== null){
                //console.log("userRegisterForm success",response);
                if(response.isValid){
                    if(response.schoolRegn=="success"){
                        if(response.authResponse && response.authResponse.user){
                            me.getUser().set(response.authResponse.user);
                        }
                        
                        if(me.getRouteHelper().getUrl()){
                            window.top.location.href = me.getRouteHelper().getUrl();
                        }else{			
                            window.top.location.href = "/contest/upload";
                        }
                    }else{
                        let schoolValid =  response.schoolValid || "Enter the details correctly";
                        me.setState({submitButtonDisabled: false, serverMessage: me.rb(schoolValid)});
                    }
                }else{
                    let schoolValid =  response.schoolValid || "Enter the details correctly";
                    me.setState({submitButtonDisabled: false, serverMessage: me.rb(schoolValid)});
                }
                
            }	
            me.setState({submitButtonDisabled: false});
		}


		var callBackFailure = function(response){
            //console.log("userRegisterForm failure",response);
			me.setState({submitButtonDisabled: false});
		}
		new NativeAjax(this.getUrlFor("CONTEST_TIC_REGN").replace("{#contestId}",this.getSelectedContestGroup()),formData).enableCORS().mask().post(callBackSuccess, callBackFailure);
		
	}

    handleChange(e) {
    	const target = e.currentTarget;	
    	this.form.validateFields(target);
        //console.log("handlechange ",target.name);
        let targetName = target.name;
        let ticChecked = false;
        let ticName = "";
        let ticEmail = "";

    	switch(targetName){
            case "act_key":
                this.setState({
                    [target.name]: (target.name=="act_key") ? target.value.toUpperCase() : target.value,
                    submitButtonDisabled: !this.form.isValid()
                });
            break;
            case "hod_name":
                ticChecked = this.state.tic_check;
                ticName = this.state.tic_name;
                this.setState({
                    [target.name]: target.value,
                    ["tic_name"]: (ticChecked) ? target.value : ticName,
                    submitButtonDisabled: !this.form.isValid()
                });
            break;
            case "hod_email":
                ticChecked = this.state.tic_check;
                ticEmail = this.state.tic_email;
                this.setState({
                    [target.name]: target.value,
                    ["tic_email"]: (ticChecked) ? target.value : ticEmail,
                    submitButtonDisabled: !this.form.isValid()
                });
            break;
            default:
            this.setState({
                [target.name]: (target.name=="act_key") ? target.value.toUpperCase() : target.value,
                submitButtonDisabled: !this.form.isValid()
            });
        }

        if(this.state.serverMessage!=""){
            this.setState({serverMessage:""})
        }
    }

    isValidContest(contestGrpId=null){
        if(!contestGrpId){
            contestGrpId = localStorage.getItem("contestType");
        }

        if(contestGrpId){
            return window.all_contests.includes(contestGrpId);
        }

        return false;           
    }

   getSelectedContestGroup(){
        let contestGrpParam = (this.props.match && this.props.match.params && this.props.match.params.contestGrpId) ? this.props.match.params.contestGrpId : localStorage.getItem("contestType");
        
        if(contestGrpParam && this.isValidContest(contestGrpParam)){
            localStorage.setItem("contestType",contestGrpParam);
        }else{
            localStorage.setItem("contestType",window.default_contest);
        }

        return localStorage.getItem("contestType");
    }    
    

    validateEmailField(val)
    {
        var emailValue = val; // To Get Value (can use getElementById)
        var splitArray = emailValue.split('@'); // To Get Array
        //console.warn("validateEmailField ",this.getSelectedContestGroup()," : ",window.allowingEmailList[this.getSelectedContestGroup()]);
        var allowingEmailList =  window.allowingEmailList[this.getSelectedContestGroup()] || window.allowingEmailList["ALL"] || [];
        //console.log("validateEmailField ",allowingEmailList," == ",splitArray[1]," : ",this.getSelectedContestGroup());
        if(allowingEmailList.length<=0){
            return false;
        }

        if(allowingEmailList.indexOf(splitArray[1]) >= 0)
        {
        // Means it has the allowed domains
        return false;
        }
        return true;
    }

    renderTchrRegistration(){
        let me = this;
        let contestName = this.getSelectedContestGroup() || 'ALL';
        let contactNum = window.contact_no_ui[contestName];
        return (
            <div className="schoolReg">
         <div className="modal-header">
         {this.rb("school.reg.title")} 
         </div>
         <div className="form-body">
         <FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
         onSubmit={this.handleRegSubmit} noValidate>
         <FormGroup for="school-name">
         <div className="school-dropdown">      
             <Select	
                 value={this.state.selectedSchoolOption}
                 onChange={this.schoolDropdownChange}
                 options={this.schoolListForReg}
                 onBlurResetsInput={false}
                 onSelectResetsInput={false}		
                 clearable={false}
                 rtl={false}
                 searchable={false}	
                 tabIndex="1"
             />
           </div>
           <FieldFeedbacks for="school-name">
             <FieldFeedback when="*" />					
         </FieldFeedbacks>	
         </FormGroup>
 
         <FormGroup for="hod_name">
             <FormControlInput type="hod_name" className="hod_name" name="hod_name" placeholder={this.rb("hod.name")}					
             value={this.state.hod_name} onChange={this.handleChange} pattern="[0-9A-Za-z_ ]+"	
             required maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4"/>					
         <FieldFeedbacks for="hod_name">
            <FieldFeedback when="valueMissing">{this.rb("billing.namerequired")}</FieldFeedback>
             <FieldFeedback when={value => (value.length<minHodNameLength)}>{this.rb("contest.hodname.minimum",[minHodNameLength])}</FieldFeedback>
             <FieldFeedback when="patternMismatch">{this.rb("contest.username.pattern")}</FieldFeedback>	
             <FieldFeedback when="*" />					
         </FieldFeedbacks>
         </FormGroup>
 
         

         <FormGroup for="hod_email">
             <FormControlInput type="hod_email" className="hod_email" name="hod_email" placeholder={this.rb("hod.email")}					
             value={this.state.hod_email} onChange={this.handleChange}	pattern="^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$"
             required  maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4"/>					
         <FieldFeedbacks for="hod_email">
             <FieldFeedback when="valueMissing">{this.rb("fpwd.emailrequired")}</FieldFeedback>
             <FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>		
             <FieldFeedback when={value => (this.validateEmailField(value))}>{this.rb("fpwd.validemailformat")}</FieldFeedback>			
         </FieldFeedbacks>	
         </FormGroup>
            
         <FormGroup className="ticcheckbox">                            
         <span className="small ticticcheck">
            <label> <input type="checkbox" name="tic_check" className="tic_check" onChange={this.handleCheck} tabIndex="4"></input>{this.rb("tic.checkinfo")}</label>
         </span>
        </FormGroup>

         {(()=>{
             if(this.state.tic_check){
                 return(
                    <FormGroup for="tic_name">	
                    <FormControlInput type="tic_name" className="tic_name" name="tic_name" placeholder={this.rb("tic.name")}					
                    value={this.state.tic_name} onChange={this.handleChange} pattern="[0-9A-Za-z_ ]+"
                    required maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" disabled={this.state.tic_check}/>					
               
                </FormGroup>
                 )
             }else{
                return(
                    <FormGroup for="tic_name">	
                    <FormControlInput type="tic_name" className="tic_name" name="tic_name" placeholder={this.rb("tic.name")}					
                    value={this.state.tic_name} onChange={this.handleChange} pattern="[0-9A-Za-z_ ]+"
                    required maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" disabled={this.state.tic_check}/>					
                <FieldFeedbacks for="tic_name">
                    <FieldFeedback when="valueMissing">{this.rb("billing.namerequired")}</FieldFeedback>
                    <FieldFeedback when={value => (value.length<minTicNameLength)}>{this.rb("contest.userid.minimum",[minTicNameLength])}</FieldFeedback>
                    <FieldFeedback when="patternMismatch">{this.rb("contest.username.pattern")}</FieldFeedback>	
                    <FieldFeedback when="*" />					
                </FieldFeedbacks>
                </FormGroup>
                 )
             }
         })()
         }

        {(()=>{
             if(this.state.tic_check){
                 return(
                <FormGroup for="tic_email">
                    <FormControlInput type="tic_email" className="tic_email" name="tic_email" placeholder={this.rb("tic.email")}					
                    value={this.state.tic_email} onChange={this.handleChange}	pattern="^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$"
                    required maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" disabled={this.state.tic_check}/>				
                </FormGroup>
                 )
             }else{
                return(
                    <FormGroup for="tic_email">
                        <FormControlInput type="tic_email" className="tic_email" name="tic_email" placeholder={this.rb("tic.email")}					
                        value={this.state.tic_email} onChange={this.handleChange}	pattern="^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$"
                        required maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" disabled={this.state.tic_check}/>					
                    <FieldFeedbacks for="tic_email">
                        <FieldFeedback when="valueMissing">{this.rb("fpwd.emailrequired")}</FieldFeedback>
                        <FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>	
                        <FieldFeedback when={value => (this.validateEmailField(value))}>{this.rb("fpwd.validemailformat")}</FieldFeedback> 				
                    </FieldFeedbacks>	
                    </FormGroup>
                     )
             }
         })()
         }

         
 
         <FormGroup for="tic_contactno">
            <span className="small ticcountrycode">{contactNum}</span>
             <FormControlInput type="tic_contactno" className="tic_contactno" name="tic_contactno" placeholder={this.rb("tic.contactno")}					
             value={this.state.tic_contactno} onChange={this.handleChange} pattern="[0-9]+"
             required maxLength={15} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4"/>					
         <FieldFeedbacks for="tic_contactno">
             <FieldFeedback when="valueMissing">{this.rb("billing.contactrequired")}</FieldFeedback>
             <FieldFeedback when="patternMismatch">{this.rb("register.mobilenolength")}</FieldFeedback>	
             {/* <FieldFeedback when={value => (value.length>0 && !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value))}>{this.rb("register.numbersonly")}</FieldFeedback> */}
             <FieldFeedback when={value => (value.length<8)}>{this.rb("contest.userid.minimum",[8])}</FieldFeedback>
             <FieldFeedback when="*" />					
         </FieldFeedbacks>
         </FormGroup>

         <FormGroup for="password_newacc">
             <FormControlInput type="password" className="password_newacc" name="password_newacc" placeholder={this.rb("contest.login.password")}						
             innerRef={password => this.password = password}
             value={this.state.password_newacc} onChange={this.handleChange} pattern="[0-9A-Za-z!@#$_-]+"
             required minLength={minPasswordLength} maxLength={15}  autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" />
             <FieldFeedbacks for="password_newacc">
             <FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
             <FieldFeedback when={value => (value.length<minPasswordLength)}>{this.rb("contest.password.minimum",[minPasswordLength])}</FieldFeedback>
             <FieldFeedback when="patternMismatch">{this.rb("validate.pwd.pattern")}</FieldFeedback>
             </FieldFeedbacks>
             </FormGroup>
 
             <FormGroup for="confirmpassword">
             <FormControlInput type="password" className="confirmpassword_newacc" name="confirmpassword_newacc" placeholder={this.rb("rpwd.confirmpwd")}
             innerRef={confirmpassword => this.confirmpassword = confirmpassword}
             value={this.state.confirmpassword_newacc} onChange={this.handleChange}	pattern="[0-9A-Za-z!@#$_-]+"			
             required minLength={minPasswordLength} maxLength={15} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" />
 
             <FieldFeedbacks for="confirmpassword_newacc">
             <FieldFeedback when="valueMissing">{this.rb("rpwd.confirmpwdrequired")}</FieldFeedback>
             <FieldFeedback when={value => (value.length<minPasswordLength)}>{this.rb("contest.password.minimum",[minPasswordLength])}</FieldFeedback>
             <FieldFeedback when="patternMismatch">{this.rb("validate.pwd.pattern")}</FieldFeedback>
             <FieldFeedback when={value => value !== this.password.value}>{this.rb("rpwd.doesnotmatch")}</FieldFeedback>
             </FieldFeedbacks>					
             </FormGroup>
 
             <FormGroup for="act_key">
                 <FormControlInput type="act_key" className="act_key" name="act_key" placeholder={this.rb("activation.key")}					
                 value={this.state.act_key} onChange={this.handleChange}  required
                 maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4"/>					
             <FieldFeedbacks for="act_key">
                 <FieldFeedback when="valueMissing">{this.rb("activation.key.required")}</FieldFeedback>
                 <FieldFeedback when="*" />					
             </FieldFeedbacks>	
             </FormGroup>
 
         
        
         <div className="clear clearfix"></div>
     
         
         <div className="server-messages">{this.state.serverMessage}</div>
         <div className="btnSect">
             <button className="submitButton AddStud" disabled={this.state.submitButtonDisabled}>Register</button>
         </div>
         </FormWithConstraints>	
         </div>
         </div>
        ) 
     }

     handleSubmit(e){
         this.showAlert("Registration ","Student Details Updated..");
     }

     nameRegexCheck(userName,type){
        if(userName.length<1){
            return;
        }
        let givenName = userName;
        let specialName = null;
        let englishName = null;
        if(givenName != null && givenName.length > 0){
        specialName = givenName.match("[\\(.+\\)].+");
        
        if(specialName != null && specialName.length > 0){
        specialName = givenName.match("[\\(.+\\)].+")[0].trim();
        }else{
        specialName = "";
        }
        
        englishName = givenName.replace(specialName, "").trim();
        specialName = (specialName !=="") ? specialName.substring(1,specialName.length-1) : specialName;
        return (type  === "english") ? englishName : specialName;
        }
    }

    specialNameChecker(value){
        if(value.length<1){
            return;
        }
        if(value && value.length>0){
            let blobValue = new Blob([value]);
            //console.log("Blob value == ",blobValue.size);
            return (blobValue.size>maxSpecialCharLength);
        }
        return false;
    }
       
    
    askUserName(value,length){
        return (value && value.length<minUserNameLength) ? true : false;
    }

     //Create Student react pattern - pattern="[0-9A-Za-z_() .-]+"
    renderCreateStudent(){
        const me = this;
        var re = new RegExp('^[a-zA-Z]{1}');
        var patternAllow = new RegExp("^[a-zA-Z][^\"\\?%$@!#%^&*+=|{}\\[\\]<>]*$"); 
        return(
            <div>
                <div className="modal-header">
                {this.rb("add.stud.title")} 
                </div>
                <div className="form-body">

                <FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
				onSubmit={this.handleCreateSubmit} noValidate>

				<FormGroup for="stud_name">
					<FormControlInput type="stud_name" className="stud_name" name="stud_name" placeholder={this.rb("stud.name")} 				
					value={this.state.stud_name} onChange={this.handleChange} 
					required maxLength={150} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4"/>					
				<FieldFeedbacks for="stud_name">
                    <FieldFeedback when="valueMissing">{this.rb("billing.namerequired")}</FieldFeedback>
                    <FieldFeedback when={value => (!re.test(value))}>{this.rb("First letter must be alphabet")}</FieldFeedback>
                    <FieldFeedback when={value => (value.length<minUserNameLength)}>{this.rb("contest.userid.minimum",[minUserNameLength])}</FieldFeedback>
                    <FieldFeedback when={value => (!patternAllow.test(value))}>{this.rb("contest.username.pattern")}</FieldFeedback>
                    
                    <FieldFeedback when={value => (this.getUserNameFn(value))}>{this.rb("contest.username.error",[minUserNameLength])}</FieldFeedback>	
                    <FieldFeedback when={value => (this.getSpecialNameFn(value))}>{this.rb("contest.special.error",[maxSpecialCharLength])}</FieldFeedback>
                    <FieldFeedback when="*" />					
                </FieldFeedbacks>	
                </FormGroup>

                <FormGroup for="stud_gender">
                <div className="radio-section"> 	
                    <span className="col-md-4 radio-caption">{this.rb("stud.gender")}</span>							
                        <div className="col-md-4 radio-group">
                   
                        <span className="radio-button">
                        <input type="radio"
                            value="m" name="stud_gender"
                            checked={this.state.stud_gender.toLowerCase() === "m"}
                            onChange={this.radioChange.bind(this)}/>
                            <label className="radio-label">{this.rb("stud.gender.boy")}</label>
                        </span>
                        </div>
                        <div className="col-md-4 radio-group">
                        <span className="radio-button">
                        <input type="radio"
                            value="f" name="stud_gender"
                            checked={this.state.stud_gender.toLowerCase() === "f"}
                            onChange={this.radioChange.bind(this)}/>
                            <label className="radio-label">{this.rb("stud.gender.girl")}</label>
                        </span>
                        </div>

                 </div>
                <FieldFeedbacks for="stud_gender">
                    <FieldFeedback when="valueMissing">{this.rb("stud.gender.required")}</FieldFeedback>
                    <FieldFeedback when="*" />					
                </FieldFeedbacks>	
                 </FormGroup>
                
                 {this.getStudentLevels()}

                {/* pattern="[0-9A-Za-z_ ]+" */}
                <FormGroup for="stud_class" >  
                <FormControlInput type="stud_class" className="stud_class" name="stud_class" placeholder={this.rb("stud.class")}				
                value={this.state.stud_class} onChange={this.handleChange} 
                required minLength={1} maxLength={20} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4"/>					
            <FieldFeedbacks for="stud_class">
                <FieldFeedback when="valueMissing">{this.rb("contest.section.required")}</FieldFeedback>
                <FieldFeedback when="patternMismatch">{this.rb("contest.username.pattern")}</FieldFeedback>	
                <FieldFeedback when={value => (value.length<1)}>{this.rb("contest.userid.minimum",[1])}</FieldFeedback>
                <FieldFeedback when="*" />					
            </FieldFeedbacks>	
            </FormGroup>

              {/* {(() => {
                if(me.prepCourseAvailable()){
                    return me.getPrepCourse();
                }
              })()} */}

				 <FormGroup for="stud_email">
					<FormControlInput type="email" className="stud_email" name="stud_email" placeholder={this.rb("stud.email")}					
					value={this.state.stud_email} onChange={this.handleChange}	pattern="^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$"
					required maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="5"/>					
				 <FieldFeedbacks for="stud_email">
                    {/* <FieldFeedback when="valueMissing">{this.rb("fpwd.emailrequired")}</FieldFeedback> */}
                    <FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>					
                </FieldFeedbacks>	
                </FormGroup>
				
				<div className="clear clearfix"></div>
			
				
				<div className="server-messages">{this.state.serverMessage}</div>
				<div className="btnSect">
				    <button className="submitButton AddStud" disabled={this.state.submitButtonDisabled}>{this.rb("stud.add.submit")}</button>
                </div>
				</FormWithConstraints>	
                </div>
               
               
            </div>

        )
    }

    /**
    * Separate function to enable Prep or not
    * IMPORTANT: Can be overridden to hide prepcourse
    */
    prepCourseAvailable(){
        if(this.getContestHost() && window.contest_prep_courses && window.contest_prep_courses.length > 0){
            return window.contest_prep_courses.includes(this.getContestHost().toUpperCase());
        }

        return true;
    }

    /**
    * Separate function to render Prep    *
    */
    getPrepCourse(){
        return(
              <FormGroup for="stud_prep">

                <div className="radio-section">     
                    <span className="col-md-4 radio-caption">{this.rb("stud.prepcourse")}</span>                            
                    <div className="col-md-4 radio-group">
                   
                        <span className="radio-button">
                        <input type="radio"
                            value="yes" name="stud_prep_status"
                            checked={this.state.stud_prep_status.toLowerCase() === "yes"}
                            onChange={this.radioChange.bind(this)}/>
                            <label className="radio-label">{this.rb("stud.prep.yes")}</label>
                        </span>
                        </div>
                        <div className="col-md-4 radio-group">
                        <span className="radio-button">
                        <input type="radio"
                            value="no" name="stud_prep_status"
                            checked={this.state.stud_prep_status.toLowerCase() === "no"}
                            onChange={this.radioChange.bind(this)}/>
                            <label className="radio-label">{this.rb("stud.prep.no")}</label>
                        </span>
                        </div>
                 </div>

                 <FieldFeedbacks for="stud_prep">
                    <FieldFeedback when="valueMissing">{this.rb("stud.prep.required")}</FieldFeedback>
                    <FieldFeedback when="*" />                  
                </FieldFeedbacks>   
                </FormGroup>
             )
    }

    /**
    * IMPORTANT: obviously, some day this has to be merged with getPrepCourse()
    **/
    getPrepCourseForEditing(prepStatusCls, prepDisbaled){
        return(
            <FormGroup for="stud_prep">
                <div className={"radio-section "+prepStatusCls}>    
                    <span className="col-md-4 radio-caption">{this.rb("stud.prepcourse")}</span>                            
                    <div className="col-md-4 radio-group">
                   
                        <span className="radio-button">
                        <input type="radio"
                            value="yes" name="stud_prep_status"
                            checked={this.state.stud_prep_status.toLowerCase() === "yes"}
                            onChange={this.radioChange.bind(this)} disabled={prepDisbaled}/>
                            <label className="radio-label">{this.rb("stud.prep.yes")}</label>
                        </span>
                        </div>
                        <div className="col-md-4 radio-group">
                        <span className="radio-button">
                        <input type="radio"
                            value="no" name="stud_prep_status"
                            checked={this.state.stud_prep_status.toLowerCase() === "no"}
                            onChange={this.radioChange.bind(this)} disabled={prepDisbaled}/>
                            <label className="radio-label">{this.rb("stud.prep.no")}</label>
                        </span>
                        </div>
                 </div>
                {/* {
                    (()=>{
                        if(prepDisbaled){
                            return(
                                <div className="prepcourse-disabled">{me.reactHtmlParser(me.rb("contest.prep.disabled"))}</div>
                            )
                        }
                    })()
                } */}
                 <FieldFeedbacks for="stud_prep">
                    <FieldFeedback when="valueMissing">{this.rb("stud.prep.required")}</FieldFeedback>
                    <FieldFeedback when="*" />                  
                </FieldFeedbacks>   
                </FormGroup>
            )
    }

    getUserNameFn(value){
        let name = this.nameRegexCheck(value,"english");
        if(typeof name === "string" && name.length>0){
           return (name.length<minUserNameLength) 
        }
        return false;
    }

    getSpecialNameFn(value){
        let name = value;
        if(typeof name === "string" && name.length>0){
           return this.specialNameChecker(this.nameRegexCheck(name,"special"));
        }
        return false;
    }

    getStudentLevels(){
        return(
             <FormGroup for="stud_level">
                <Select 
                    value={this.state.selectedLevelOption}
                    onChange={this.levelDropdownChange}
                    options={this.schoolLevelList}
                    onBlurResetsInput={false}
                    onSelectResetsInput={false}     
                    clearable={false}
                    rtl={false}
                    searchable={false}  
                    tabIndex="1"
                  />
                <FieldFeedbacks for="stud_level">
                    {/* <FieldFeedback when={value => (value === selectLevelReq)}>{this.rb("Select Level is requird")}</FieldFeedback> */}
                    {/* <FieldFeedback when="valueMissing">{this.rb("stud.class.required")}</FieldFeedback> */}
                    <FieldFeedback when="*" />                  
                </FieldFeedbacks>
                </FormGroup>
            )
    }

    renderEditStudent(){
        let me=this;
        let userData = this.props.userData || null;
        let prepDisbaled = false;
        let actStatus =  this.props.status || "pending";
        if(userData && userData["Prep Course"] && actStatus=="registered"){
            prepDisbaled = (userData["Prep Course"].toLowerCase() === "yes") ? true : false;
        }
    
        let prepStatusCls = "";
        if(prepDisbaled){
            prepStatusCls = "disabled"
        }
        //console.log("actStatus ",actStatus," : ",prepDisbaled);
        var re = new RegExp('^[a-zA-Z]{1}');
        var patternAllow = new RegExp("^[a-zA-Z][^\"\\?%$@!#%^&*+=|{}\\[\\]<>]*$");
        //[^`~!@#$%^&*\\(\\)+={}\\[\\];:'\",<>\\/\\\\|0-9?]*
        //pattern="[0-9A-Za-z_ ]+"
        return(
            <div>
            <div className="modal-header">
            {this.rb("stud.edit.title")}
            </div>
            <div className="form-body">
            <FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
            onSubmit={this.handleEditSubmit} noValidate>
            <FormGroup for="stud_name" >
                <FormControlInput type="stud_name" className="stud_name" name="stud_name" placeholder={this.rb("stud.name")}				
                value={this.state.stud_name} onChange={this.handleChange} 
                required maxLength={150} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4"/>					
            <FieldFeedbacks for="stud_name">
                <FieldFeedback when="valueMissing">{this.rb("billing.namerequired")}</FieldFeedback>
                <FieldFeedback when={value => (!re.test(value))}>{this.rb("First letter must be alphabet")}</FieldFeedback>
                {/* <FieldFeedback when="patternMismatch">{this.rb("contest.username.pattern")}</FieldFeedback>	 */}
                <FieldFeedback when={value => (value.length<minUserNameLength)}>{this.rb("contest.userid.minimum",[minUserNameLength])}</FieldFeedback>
                <FieldFeedback when={value => (!patternAllow.test(value))}>{this.rb("contest.username.pattern")}</FieldFeedback>	
                <FieldFeedback when={value => (this.getUserNameFn(value))}>{this.rb("contest.username.error",[minUserNameLength])}</FieldFeedback>	
                <FieldFeedback when={value => (this.getSpecialNameFn(value))}>{this.rb("contest.special.error",[maxSpecialCharLength])}</FieldFeedback>
                <FieldFeedback when="*" />					
            </FieldFeedbacks>	
            </FormGroup>

            <FormGroup for="stud_gender">
            <div className="radio-section"> 	
                <span className="col-md-4 radio-caption">{this.rb("stud.gender")}</span>							
                    <div className="col-md-4 radio-group">
               
                    <span className="radio-button">
                    <input type="radio"
                        value="m" name="stud_gender"
                        checked={this.state.stud_gender.toLowerCase() === "m"}
                        onChange={this.radioChange.bind(this)}/>
                        <label className="radio-label">{this.rb("stud.gender.boy")}</label>
                    </span>
                    </div>
                    <div className="col-md-4 radio-group">
                    <span className="radio-button">
                    <input type="radio"
                        value="f" name="stud_gender"
                        checked={this.state.stud_gender.toLowerCase() === "f"}
                        onChange={this.radioChange.bind(this)}/>
                        <label className="radio-label">{this.rb("stud.gender.girl")}</label>
                    </span>
                    </div>
             </div>
             <FieldFeedbacks for="stud_gender">
                    <FieldFeedback when="valueMissing">{this.rb("stud.gender.required")}</FieldFeedback>
                    <FieldFeedback when="*" />					
                </FieldFeedbacks>
             </FormGroup>

             {this.getStudentLevels()}
            

                <FormGroup for="stud_class" >
                <FormControlInput type="stud_class" className="stud_class" name="stud_class" placeholder={this.rb("stud.class")}				
                value={this.state.stud_class} onChange={this.handleChange} 
                required minLength={1} maxLength={20} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4"/>					
            <FieldFeedbacks for="stud_class">
                <FieldFeedback when="valueMissing">{this.rb("contest.section.required")}</FieldFeedback>
                <FieldFeedback when="patternMismatch">{this.rb("contest.username.pattern")}</FieldFeedback>	
                <FieldFeedback when={value => (value.length<1)}>{this.rb("contest.userid.minimum",[1])}</FieldFeedback>
                <FieldFeedback when="*" />					
            </FieldFeedbacks>	
            </FormGroup>
                        
             {/* {(() => {
                if(me.prepCourseAvailable()){
                    return me.getPrepCourseForEditing(prepStatusCls, prepDisbaled);
                }
              })()} */}

             <FormGroup for="stud_email" >
                <FormControlInput type="email" className="stud_email" name="stud_email" placeholder={this.rb("stud.email")}					
                value={this.state.stud_email} onChange={this.handleChange}	pattern="^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$"
                required maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="5"/>					
             <FieldFeedbacks for="stud_email">
                {/* <FieldFeedback when="valueMissing">{this.rb("fpwd.emailrequired")}</FieldFeedback> */}
                <FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>					
            </FieldFeedbacks>	
            </FormGroup>
            
            <div className="clear clearfix"></div>
        
            
            <div className="server-messages">{this.state.serverMessage}</div>
            <div className="btnSect">
                <button className="submitButton EditStud" disabled={this.state.submitButtonDisabled}>{this.rb("stud.edit.save")}</button>
            </div>
            </FormWithConstraints>	
            </div>
           
           
        </div>

        )
    }

    

    renderUserprofileData(){
        let type = this.props.type  || '';

        switch(type)
        {
            case "create":
            return(
                <div>
                    {this.renderCreateStudent()}
                </div>
            )
            case "edit":
            return(
                <div>
                {this.renderEditStudent()}
                </div>
            )
            case "register":
            return(
                <div>
                {this.renderTchrRegistration()}
                </div>
            )
            default:
            return(
                <div>
                {this.showLoader()}
                </div>
            )   
        }
    }

    getCount(forceLoad=false){
        if(typeof this.props.getCount === "function"){
            this.props.getCount(forceLoad);
        }
    }

    render(props){
        return(
            <TestTakingModalComponent visible={this.props.modalShow} dialogClassName="modal-md-6">
            <div className="loginHeader text-center">	
            <div className="text-center modallogo loginHeaderTxt">
            </div>
            <div className="close loginClose" onClick={this.hideAdminModal}  aria-label="Close">
            <span aria-hidden="true"><i className="material-icons">close</i></span>
            </div>
            </div>
            <div className="modal-body">
                {this.renderUserprofileData()}
            </div>							
            </TestTakingModalComponent>
        )
    }
}

ComponentRegistry.register("ri_adminModal", AdminModal);


// WEBPACK FOOTER //
// ./src/views/registration/AdminModal.js